// Quarantine router
export default [
  {
    path: 'quarantine',
    name: 'quarantine',
    redirect: 'quarantine/index',
    component: () =>
      import(
        /* webpackChunkName: "quarantine" */ '../views/quarantine/Quarantine.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'quarantineIndex',
        meta: {
          tabbable: true,
          tableKeys: ['quarantine'],
          filterKeys: ['quarantine'],
          formKeys: [],
          routePermissions: ['quarantineView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "quarantineIndex" */ '../views/quarantine/QuarantineIndex.vue'
          ),
      },
      {
        path: ':sampleId',
        name: 'quarantineEdit',
        meta: {
          menuActiveRouteName: 'quarantineIndex',
          routePermissions: ['quarantineView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "quarantineIndex" */ '../views/quarantine/QuarantineIndex.vue'
          ),
      },
    ],
  },
];
